import * as React from 'react';
import { SVGProps } from 'react';

const IconBarrierSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-6H0v-4h9V4zm15 6h-5v4h5v-4z" />
  </svg>
);
export default IconBarrierSizeM;
